import React, { useMemo } from 'react';
import { EventSliderItemProps } from 'components/molecules/EventSliderItem/EventSliderItem.types';
import { EventSliderItemStyled, RowGridStyled } from './OverviewEvents.styles';

const EventsList = ({
  events,
  sortOrder,
  cursor,
}: {
  events: EventSliderItemProps[];
  sortOrder: string;
  cursor: number;
}) => {
  const computedGridItems = useMemo(() => {
    const sortedEvents = [...events].slice(0, cursor).sort((a, b) => {
      if (sortOrder === 'asc') {
        return Number(a._dateToSort) - Number(b._dateToSort);
      } else {
        return Number(b._dateToSort) - Number(a._dateToSort);
      }
    });
    return sortedEvents;
  }, [events, sortOrder, cursor]);

  return (
    <RowGridStyled>
      {computedGridItems.map((item, index: number) => (
        <EventSliderItemStyled
          key={`event-box_${index}`}
          link={item.link}
          image={item.image}
          text={item.text}
          date={item.date}
          time={item.time}
        />
      ))}
    </RowGridStyled>
  );
};

export default EventsList;
